import React, { useEffect, useRef } from "react";
import { Box, Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";
import { useTheme } from "@mui/material/styles";
import { makeStyles } from "@material-ui/core";
import Tooltip from "@mui/material/Tooltip";
import questionMark from "../images/info-icon.png";
import { postToHubSpot } from "../api/APIs";

const SliderCard = ({ item, zipcode }) => {
  const classes = useStyles();
  const theme = useTheme();

  const Button = styled(MuiButton)((props) => ({
    borderRadius: "10vw",
    background: "#FFD27D",
    whiteSpace: "nowrap",
  }));

  useEffect(() => {
    console.log("item===>", item);
  }, [item]);

  const handleSendForm = (card) => {
    const userInfo = localStorage.getItem("userInfo");
    const status = "Enrollment Click";
    if (userInfo) {
      const user = JSON.parse(userInfo);
      postToHubSpot(user.firstName, user.lastName, user.email, status).then((res) => {
          const href = `https://enroll.bkvenergy.com/Home/index?ProductCode=${card.ProductId}&Term=${card.Terms}&zipcode=${zipcode}`;
          window.location.href = href;
      })
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        // padding: "30px",
        width: "100%",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      {item.map((card) => {
        return (
          <Box
            sx={{
              display: "inline-block",
              whiteSpace: "nowrap",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center",
              width: "90%",
              borderRadius: "15px",
              backgroundColor: "#fff",
              margin: "10px",
              boxShadow: "0px 0px 25px 0px rgba(0, 0, 0, 0.25)",
              [theme.breakpoints.down('md')]: {
                width: '100%',
              },
              [theme.breakpoints.up('lg')]: {
                width: '80%',
              },
              [theme.breakpoints.up(1920)]: {
                width: '60%',
              },
            }}
          >
            <Box
              sx={{
                padding: { xs: "30px 10px", lg: "30px 25px" },
                display: "flex",
                flexDirection: { lg: "row", sm: "column" },
                justifyContent: "space-between",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", lg: "row" },
                  width: { xs: "50%", sm: '100%' },
                  // justifyContent: "space-between",
                  alignItems: "center",
                  boxSizing: 'border-box',
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "center",
                    alignItems: "center",
                    //width: "100%",
                    border: "1px solid #a5b7c3",
                    padding: "18px 10px",
                    borderRadius: "15px",
                    marginRight: { xs: "0", lg: "30px" },
                    marginBottom: { xs: "20px", lg: "0" },
                  }}
                >
                  <Box
                    width="50%"
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      sx={{
                        fontSize: "32px",
                        color: "#009A88",
                        fontWeight: "600",
                      }}
                      //  align="center"
                      variant="body2"
                    >
                      {card.kWh2000}
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "14px",
                        fontWeight: "400",
                      }}
                      align="center"
                      variant="body1"
                    >
                      per kWh
                      <br />
                      *based on 2000 kWh
                    </Typography>
                  </Box>
                </Box>

                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "flex-start",
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: "24px",
                      color: theme.palette.primary.main,
                      whiteSpace: { xs: "nowrap", sm: 'wrap' },
                      textTransform: "capitalize",
                      // marginBottom: { xs: "10%", sm: "10%", md: "6%", lg: "2%" },
                    }}
                    // style={{ whiteSpace: {sm:'wrap', xs:'nowrap'}}}
                    // align="center"
                    variant="body2"
                  // padding={{ xs: "0 10%", sm: "0 10%", md: "0 10%", lg: "0 5%" }}
                  >
                    {card.Title}
                  </Typography>
                  <ul style={{ marginLeft: "1.5rem" }}>
                    <li style={{ fontSize: "14px" }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: '#2F2F2F',
                          fontWeight: '600'
                        }}
                        variant="body1"
                      >
                        Energy Charge: {(parseFloat(card.ENERGYCHARGE) * 100).toFixed(2)}¢
                      </Typography>
                    </li>

                    <li style={{ fontSize: "14px" }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: '#2F2F2F',
                          fontWeight: '600'
                        }}
                        variant="body1"
                      >
                        Term: {card.Terms} months
                      </Typography>
                    </li>
                    <li style={{ fontSize: "14px" }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: '#2F2F2F',
                          fontWeight: '600'
                        }}
                        variant="body1"
                      >
                        Plan type: {card.CategoryName}
                      </Typography>
                    </li>
                    <li style={{ fontSize: "14px" }}>
                      <Typography
                        sx={{
                          fontSize: "14px",
                          color: '#2F2F2F',
                          fontWeight: '600'
                        }}
                        variant="body1"
                      >
                        Renewable: {card.Renewable}%
                      </Typography>
                    </li>
                  </ul>
                </Box>
              </Box>
              <Link
                underline="none"
                href={`https://enroll.bkvenergy.com/Home/index?ProductCode=${card.ProductId}&Term=${card.Terms}&zipcode=${zipcode}`}
                //https://test-signupnew.bkvenergy.com/Home/Plans?productcode=RN12000107
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  width: { xs: "50%", lg: "30%", sm: "100%" },
                  marginTop: { sm: "10px" }
                }}
              >
                <Button
                  className={classes.button}
                  sx={{
                    padding: { lg: "18px 10px", sm: "8px 10px" },
                    width: { lg: "100%", sm: "60%" },
                  }}
                  onClick={() => handleSendForm(card)}
                >
                  <Typography
                    fontSize={{
                      xs: "2.5vw",
                      sm: "2.5vw",
                      md: "20px",
                      lg: "21px",
                    }}
                    sx={{ lineHeight: "21px", fontWeight: "900" }}
                  >
                    SELECT
                  </Typography>
                </Button>
              </Link>

            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default SliderCard;

const useStyles = makeStyles((theme) => ({
  button: {
    transition: "all .1s ease-in-out",
    border: "3px solid #FFD27D",
    "&:hover": {
      // // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
      background: "transparent",
    },
  },
  "@keyframes scale": {
    "0%": {
      // transform: "scale(1.05, 1.05)",
      animation: "$scale .2s ease-in-out",
    },
    "50%": {
      transform: "scale(1.03, 1.03)",
    },
    "100%": {
      transform: "scale(1)",
    },
  },
}));
